/**
 * Captcha generate API returns encryptedData as a string or plain object.
 */
function isPresentCaptchaEncryptedData(encryptedData) {
  if (encryptedData == null) return false;
  if (typeof encryptedData === "string") {
    return encryptedData.trim().length > 0;
  }
  if (typeof encryptedData === "object") {
    return Object.keys(encryptedData).length > 0;
  }
  return false;
}

export { isPresentCaptchaEncryptedData };
